import { Reducer } from 'redux';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/PassPhrase/types';
import { PassPhraseState, PassPhraseActions, MEMBER_SETTINGS_PASS_PHRASE__SET_ACCESSIBLE_STEP, MEMBER_SETTINGS_PASS_PHRASE__RESET_CACHE } from './types';

const initialState: PassPhraseState = {
  process: {
    accessibleSteps: [ProcessStepCodesEnum.Auth]
  }
};

const passPhraseReducer: Reducer<PassPhraseState, PassPhraseActions> = (state = initialState, action): PassPhraseState => {
  switch (action.type) {
    // 設置可訪問步驟
    case MEMBER_SETTINGS_PASS_PHRASE__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 重置資料緩存
    case MEMBER_SETTINGS_PASS_PHRASE__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default passPhraseReducer;
